import type { FilterOperatorOption } from "metabase/querying/filters/types";
import type * as Lib from "metabase-lib";

export type OperatorOption = FilterOperatorOption<Lib.DefaultFilterOperator>;
